import React from "react";
import Template from "../../../components/Dashboard/Template";
import TableData from "../../../dumyData/education/EducationNewAdmissions.json";
import DynamicTable from "../../../components/DynamicTable";

const headerData = [
  "Join Date",
  "Student Detail",
  "Source",
  "Class",
  "Admission Fee",
  "Payment Type",
  "Status",
  "Action",
];

const displayRows = [
  "date_time",
  "ed_student_detail",
  "source",
  "ed_student_class",
  "ed_student_fee",
  "ed_fess_payment_type",
  "ed_fess_payment_status",
  "actions",
];

const NewAddmissions = () => {
  return (
    <Template primaryHeading={"New Admissions"} secondaryHeading={"Latest"}>
      <DynamicTable
        tableHeader={headerData}
        displayRows={displayRows}
        tableData={TableData}
        showDetail={true}
        handleNavigate={() => console.log("hell")}
      />
    </Template>
  );
};

export default NewAddmissions;
